import * as React from 'react';

export default function BirthdayCake({
  className,
  viewBox = '0 0 24 24',
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg className={className} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2C12.5523 2 13 2.44772 13 3V3.5C13 4.05228 12.5523 4.5 12 4.5C11.4477 4.5 11 4.05228 11 3.5V3C11 2.44772 11.4477 2 12 2Z"
        fill="currentColor"
      />
      <path
        d="M7 4.5C7.55228 4.5 8 4.94772 8 5.5V6C8 6.55228 7.55228 7 7 7C6.44772 7 6 6.55228 6 6V5.5C6 4.94772 6.44772 4.5 7 4.5Z"
        fill="currentColor"
      />
      <path
        d="M17 4.5C17.5523 4.5 18 4.94772 18 5.5V6C18 6.55228 17.5523 7 17 7C16.4477 7 16 6.55228 16 6V5.5C16 4.94772 16.4477 4.5 17 4.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 8.5C4.89543 8.5 4 9.39543 4 10.5V13.1707C4.3128 13.0602 4.64936 13 5 13C5.5627 13 6.07954 13.1547 6.5 13.4189C6.92046 13.1547 7.4373 13 8 13C8.5627 13 9.07954 13.1547 9.5 13.4189C9.92046 13.1547 10.4373 13 11 13C11.5627 13 12.0795 13.1547 12.5 13.4189C12.9205 13.1547 13.4373 13 14 13C14.5627 13 15.0795 13.1547 15.5 13.4189C15.9205 13.1547 16.4373 13 17 13C17.5627 13 18.0795 13.1547 18.5 13.4189C18.9205 13.1547 19.4373 13 20 13V10.5C20 9.39543 19.1046 8.5 18 8.5H6Z"
        fill="currentColor"
      />
      <path
        d="M20 15C19.4477 15 19 15.4477 19 16C19 16.5523 18.5523 17 18 17C17.4477 17 17 16.5523 17 16C17 15.4477 16.5523 15 16 15C15.4477 15 15 15.4477 15 16C15 16.5523 14.5523 17 14 17C13.4477 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 10.5523 17 10 17C9.44772 17 9 16.5523 9 16C9 15.4477 8.55228 15 8 15C7.44772 15 7 15.4477 7 16C7 16.5523 6.55228 17 6 17C5.44772 17 5 16.5523 5 16C5 15.4477 4.55228 15 4 15V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V15Z"
        fill="currentColor"
      />
    </svg>
  );
}
